
export enum PortalEnum {
  ClassSessionPortal = 0,
  ParentPortal = 1,
  ScreenerPortal = 2,
  PublicSelfPortal = 3,
  SessionBookingPortal = 6
}
